import { mutations } from './mutations';
import { actions } from './actions';
export var FormRequestError;
(function (FormRequestError) {
    FormRequestError[FormRequestError["NO_ERROR"] = 0] = "NO_ERROR";
    FormRequestError[FormRequestError["TOO_MANY_RESULTS"] = 1] = "TOO_MANY_RESULTS";
})(FormRequestError || (FormRequestError = {}));
export var state = {
    forms: [],
    formCounts: {
        total: 0,
        filtered: 0,
    },
    loading: false,
    searchQuery: '',
    pagination: {
        per_page: 50,
        page: 1,
    },
    paginationResponse: null,
    error: FormRequestError.NO_ERROR,
};
export var forms = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
